import { useStore } from 'vuex';
import Swal from 'sweetalert2';
import 'sweetalert2/src/sweetalert2.scss';

/**
 * Composable para gestionar la API de bancos de la empresa
 * @returns {Object} - Métodos para gestionar bancos de la empresa
 */
export function useCompanyBankAPI() {
  const store = useStore();

  /**
   * Obtiene la lista de bancos de la empresa
   * @returns {Promise<Array>} - Lista de bancos de la empresa
   */
  const getCompanyBanks = async () => {
    const params = {
      url: "user/company_bank/all",
      params: {
        active: 1,
        order_by: "id",
        order_value: "asc",
      },
    };

    try {
      const response = await store.dispatch('getData', params);
      if (response.code === 200) {
        return response.data;
      }
      Swal.fire({
        title: "Error",
        text: "Ocurrió un error al cargar los bancos de la empresa",
        icon: "error",
        showConfirmButton: true,
      });
      return [];
    } catch (error) {
      console.error('Error loading company banks:', error);
      Swal.fire({
        title: "Error",
        text: "Ocurrió un error al cargar los bancos de la empresa",
        icon: "error",
        showConfirmButton: true,
      });
      return [];
    }
  };

  return {
    getCompanyBanks,
  };
}
